import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { adviceAPI, paymentAPI } from '../services/api';


const PaymentSuccessPopup = ({ onClose }) => (
  <div style={{
    position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.45)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
  }}>
    <div style={{
      backgroundColor: 'white', borderRadius: '16px', padding: '2.5rem 2rem',
      maxWidth: '420px', width: '90%', textAlign: 'center',
      boxShadow: '0 8px 40px rgba(0,0,0,0.18)',
    }}>
      <div style={{ marginBottom: '1rem' }}>
        <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="#38a169" strokeWidth="2.2"
          strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/><polyline points="9 12 11 14 15 10"/>
        </svg>
      </div>
      <h2 style={{ fontSize: '1.3rem', fontWeight: '800', color: '#1a365d', marginBottom: '0.75rem' }}>
        Тўлов муваффақиятли амалга оширилди!
      </h2>
      <p style={{ fontSize: '0.95rem', color: '#4a5568', lineHeight: '1.65', marginBottom: '1.5rem' }}>
        Сўровингиз қабул қилинди. Жавобни Менинг маслахатларим саҳифасида тез фурсатда оласиз.
      </p>
      <button
        onClick={onClose}
        style={{
          backgroundColor: '#1a365d', color: 'white', border: 'none',
          padding: '0.8rem 2rem', borderRadius: '10px', fontSize: '0.95rem',
          fontWeight: '600', cursor: 'pointer',
        }}
      >
        Тушунарли
      </button>
    </div>
  </div>
);

const ClientConsultations = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showPaidPopup, setShowPaidPopup] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('paid') === '1') {
      const aid = params.get('aid');
      window.history.replaceState({}, '', '/client/consultations');
      if (aid) {
        // Verify actual payment status before showing success popup
        paymentAPI.getStatus(aid)
          .then(res => { if (res.data?.payment_status === 'paid') setShowPaidPopup(true); })
          .catch(() => {});
      } else {
        setShowPaidPopup(true); // fallback for old URLs without aid
      }
    }
  }, [location.search]);

  useEffect(() => {
    adviceAPI.getMyRequests()
      .then(res => {
        const rows = res.data || [];
        setItems(rows);
        // Mark unread answers as read
        rows.forEach(item => {
          if (item.crm_status === 'answered' && !item.answer_read) {
            adviceAPI.markAnswerRead(item.id).catch(() => {});
          }
        });
      })
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  const getStatusLabel = (item) => {
    if (item.crm_status === 'answered') return { label: 'Жавоб берилди', bg: '#f0fff4', color: '#276749' };
    if (item.payment_status === 'pending') return { label: 'Жараёнда', bg: '#fef3c7', color: '#92400e' };
    return { label: 'Жараёнда', bg: '#fef3c7', color: '#92400e' };
  };

  if (loading) return <div style={styles.center}>Юкланмоқда...</div>;

  return (
    <div style={styles.page}>
      {showPaidPopup && <PaymentSuccessPopup onClose={() => setShowPaidPopup(false)} />}

      <div style={styles.container}>
        <h1 style={styles.title}>Маслахат олишга сўровларим</h1>

        {items.length === 0 ? (
          <div style={styles.empty}>
            <div style={styles.emptyIcon}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#cbd5e0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.4 2 2 0 0 1 3.6 1.21h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.8a16 16 0 0 0 6 6l.86-.86a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
              </svg>
            </div>
            <p style={styles.emptyText}>Сизда ҳали маслаҳат сўровлари йўқ</p>
            <button style={styles.btnPrimary} onClick={() => navigate('/request-advice')}>
              Маслахат олиш
            </button>
          </div>
        ) : (
          <>
            <div style={styles.list}>
              {items.map((item, i) => {
                const st = getStatusLabel(item);
                return (
                  <div key={item.id || i} style={styles.card}>
                    <div style={styles.cardTop}>
                      <span style={{ ...styles.statusTag, backgroundColor: st.bg, color: st.color }}>
                        {st.label}
                      </span>
                      <span style={styles.date}>{item.created_at ? new Date(item.created_at).toLocaleDateString('uz-UZ') : ''}</span>
                    </div>
                    <p style={styles.cardDesc}>{item.description || item.message || item.question}</p>
                    {item.crm_status === 'answered' && item.answer && (
                      <div style={{
                        marginTop: '0.75rem', backgroundColor: '#f0fff4',
                        border: '1px solid #c6f6d5', borderRadius: '10px', padding: '0.85rem 1rem',
                      }}>
                        <div style={{ fontSize: '0.78rem', color: '#276749', fontWeight: '600', marginBottom: '0.4rem' }}>
                          💬 {item.staff_name || 'Мутахассис'}
                          {item.answered_at && (
                            <span style={{ fontWeight: '400', marginLeft: '0.5rem', color: '#4a7766' }}>
                              · {new Date(item.answered_at).toLocaleDateString('uz-UZ')}
                            </span>
                          )}
                        </div>
                        <div style={{ color: '#276749', fontSize: '0.92rem', lineHeight: '1.6' }}>{item.answer}</div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            <div style={{ textAlign: 'center', marginTop: '2rem' }}>
              <button style={styles.btnPrimary} onClick={() => navigate('/request-advice')}>
                Яна маслахат олиш
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const styles = {
  page: { backgroundColor: '#f7fafc', minHeight: 'calc(100vh - 120px)', padding: '3rem 2rem' },
  container: { maxWidth: '800px', margin: '0 auto' },
  title: { fontSize: '1.8rem', fontWeight: '800', color: '#1a365d', marginBottom: '2rem' },
  center: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh', fontSize: '1rem', color: '#718096' },
  empty: { textAlign: 'center', padding: '4rem 2rem', backgroundColor: 'white', borderRadius: '16px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' },
  emptyIcon: { marginBottom: '1rem' },
  emptyText: { fontSize: '1.05rem', color: '#718096', marginBottom: '1.5rem' },
  list: { display: 'flex', flexDirection: 'column', gap: '1rem' },
  card: { backgroundColor: 'white', borderRadius: '12px', padding: '1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0' },
  cardTop: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' },
  statusTag: { fontSize: '0.8rem', padding: '0.2rem 0.65rem', borderRadius: '20px', fontWeight: '600' },
  date: { fontSize: '0.8rem', color: '#a0aec0' },
  cardDesc: { fontSize: '0.9rem', color: '#718096', lineHeight: '1.6' },
  btnPrimary: {
    backgroundColor: '#FFD700', color: '#0d1f17', border: 'none',
    padding: '0.85rem 2rem', borderRadius: '50px', fontSize: '0.95rem',
    fontWeight: '700', cursor: 'pointer',
  },
};

export default ClientConsultations;
